import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    dialog: false,
    dialog_filter: false,
    loading: false,
    keywords: [],
    keyword: {},
    order_column: 'name',
    order_type: 'asc',
    filter: {},
    asset_labels: [],
  },

  mutations: {
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogFilter(state, payload) {
       state.dialog_filter = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    },
    setKeywords(state, payload) {
      state.keywords = payload
    },
    setSelectedKeyword(state, payload) {
      state.keyword = payload
    },
    setAssetLabels(state, payload) {
      state.asset_labels = payload
    },
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/keywords', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setKeywords',r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
          .post('cms/youtube/keywords', {
            label: state.keyword.label,
            keywords: state.keyword.keywords,
          })
          .then(() => {
            commit('setDialog', false)
            commit('setSelectedKeyword', {})
            dispatch('read')
          })
    },
    delete({ commit, dispatch, state }, id) {
      axios.admin
          .delete('cms/youtube/keywords/' + id)
          .then(() => {
            dispatch('read')
          })
    },
    updateStatus({ commit, dispatch, state }, payload) {
      axios.admin
          .put('cms/youtube/keyword/status', {
            id: payload.id,
            status: payload.status
          })
          .then(() => {
            dispatch('read')
          })
    },
    readAssetLabels({ state, commit }) {
      commit('setLoading', true)
      axios.admin
          .get('cms/youtube/user/assetlabel')
          .then(r => {
            commit('setAssetLabels', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    }
  }
}
